import React, { useEffect, useState, useMemo, useCallback } from "react";
import { getRolUser, anullUserRol, enableUserRol } from "../../interpreter/role";
import AppDataTable from "./AppDataTable";
import Icon from '@mdi/react';
import {
  mdiLockOpenCheck,
  mdiTextBoxEditOutline,
  mdiLockAlert,
} from '@mdi/js';
import { permissionTranslations } from "../../services/diccionaryRole";

export const RolesList = ({ roles, setRoles, openModal, refresh, onSuccess }) => {
  const [loading, setLoading] = useState(true);

  const fetchRoles = useCallback(async () => {
    setLoading(true);
    try {
      const data = await getRolUser();
      if (data.succes === "2") {
        setRoles(data.user);
      } else if (data.succes === "1") {
        console.error("No existen datos de usuarios.");
      } else {
        console.error("Errores de conexión en el servidor.");
      }
    } catch (error) {
      console.error("Error en el Servidor", error);
    } finally {
      setLoading(false);
    }
  }, [setRoles]);

  useEffect(() => {
    fetchRoles();
  }, [fetchRoles, refresh]);

  const handleAnullUser = useCallback(async (id_users) => {
    try {
      const response = await anullUserRol(id_users);
      alert(response.message);
      onSuccess();
    } catch (err) {
      console.warn("Las siguientes fallas son:", err);
      return [];
    }
  }, [onSuccess]);

  const handleEnableUser = useCallback(async (id_users) => {
    try {
      const response = await enableUserRol(id_users);
      alert(response.message);
      onSuccess();
    } catch (err) {
      console.warn("Los siguientes errores son:", err);
      return null;
    }
  }, [onSuccess]);

  const columns = useMemo(() => [
    {
      name: "ID",
      selector: row => row.id,
      sortable: true,
      width: "80px",
    },
    {
      name: "Correo",
      selector: row => row.email,
      sortable: true,
      width: "190px",
    },
    {
      name: "Rol",
      selector: row =>
        Array.isArray(row.roles)
          ? (row.roles.length > 0 ? row.roles[0].name : "Sin rol")
          : (row.roles?.name || "Sin rol"),
      width: "250px",
    },
    {
      name: "Permisos",
      cell: row => (
        <div className="text-left whitespace-pre-wrap">
          {Array.isArray(row.permissions) && row.permissions.length > 0
            ? row.permissions.map((p, index) => (
                <div key={index}>📌 {permissionTranslations[p.name] || p.name}</div>
              ))
            : "Sin permisos"}
        </div>
      ),
      width: "320px",
    },
    {
      name: "Estado",
      selector: row =>
        parseInt(row.status, 10) === 1 ? "Activo" : "Inactivo",
      width: "150px",
    },
    {
      name: "Acciones",
      cell: row => (
        <div className="flex flex-row space-x-2">
          <button
            onClick={() => openModal("permiss", row)}
            className="bg-blue-600 hover:bg-blue-300 text-white text-sm py-1 px-1 rounded flex items-center justify-center gap-2 w-full"
          >
            <Icon path={mdiTextBoxEditOutline} size={1.2} />
          </button>
          <button
            onClick={() => handleAnullUser(row.id)}
            className="bg-red-600 hover:bg-red-300 text-white text-sm py-1 px-1 rounded flex items-center justify-center gap-2 w-full"
          >
            <Icon path={mdiLockAlert} size={1.2} />
          </button>
          <button
            onClick={() => handleEnableUser(row.id)}
            className="bg-blue-600 hover:bg-blue-400 text-white text-sm py-1 px-1 rounded flex items-center justify-center gap-2 w-full"
          >
            <Icon path={mdiLockOpenCheck} size={1.2} />
          </button>
        </div>
      ),
      width: "160px",
    },
  ], []);

  const customStyles = {
    headCells: {
      style: {
        fontWeight: "bold",
        textAlign: "center",
        justifyContent: "center",
        backgroundColor: "#f3f4f6",
        padding: "12px",
        fontSize: "17px",
      },
    },
    cells: {
      style: {
        textAlign: "center",
        justifyContent: "center",
        minHeight: "60px",
        paddingTop: "10px",
        paddingBottom: "10px",
        fontSize: "14px",
      },
    },
  };

  return (
    <div>
      {loading ? (
        <div className="flex justify-center items-center h-40">
          <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-blue-500 border-solid"></div>
        </div>
      ) : (
        <AppDataTable
          title="Listado de Usuarios"
          columns={columns}
          data={roles}
          scrollHeight="500px"
          customStyles={customStyles}
        />
      )}
    </div>
  );
};
